import React, {useEffect, useState} from "react";
import {useDispatch, connect} from "react-redux";
import {useParams} from "react-router-dom";
import {Formik} from "formik";
import {number, object, string} from "yup";
import Grid from "@mui/material/Grid2";
import {Water as WaterIcon} from "@mui/icons-material";
import {prestationsActions} from "../../modules/prestations/prestations.actions.js";
import PageTitle from "./layout/PageTitle.js";
import TypologieLavageDataField from "./prestations/form/TypologieLavageDataField.js";
import SubmitButton from "./layout/forms/SubmitButton.js";
import Loader from "./layout/loading/loader.js";

const typologieLavageValidationSchema = object({
    libelle: string()
        .required("Le libellé est requis")
        .max(255, "Le libellé ne doit pas dépasser 255 caractères"),
    couleur: string()
        .required("La couleur est requise")
        .matches(/^#([0-9A-Fa-f]{3}){1,2}$/, "Format de couleur invalide (ex: #FFAA00)"),
    // REP-03 R7 : matrice eau du bilan par actes (L/bac, estimation) — vide = pas d'estimation
    consoEauLitresParBac: number()
        .transform((v, orig) => (orig === '' || orig === null ? null : v))
        .nullable()
        .min(0, "La consommation ne peut pas être négative")
        .typeError("Nombre attendu (ex: 30)"),
});

function TypologieLavageNewOrEdit({...props}) {
    const dispatch = useDispatch();
    const params = useParams();
    const [mode, setMode] = useState("create");
    const [typologieId, setTypologieId] = useState(null);

    useEffect(() => {
        if (params.hasOwnProperty("id")) {
            setMode("edit");
            setTypologieId(params.id);
        } else {
            setMode("create");
            setTypologieId(null);
        }
    }, [params]);

    useEffect(() => {
        if (typologieId && (!props.typologie || props.typologie.id !== parseInt(typologieId)) && !props.loading && !props.error) {
            dispatch(prestationsActions.fetchTypologie(typologieId));
        }
    }, [dispatch, typologieId]);

    const handleSubmit = (rawValues) => {
        const conso = rawValues.consoEauLitresParBac;
        const values = {
            ...rawValues,
            consoEauLitresParBac: conso === '' || conso === null || conso === undefined ? null : Number(conso),
        };
        if (mode === "create") {
            dispatch(prestationsActions.createTypologie(values));
        } else {
            dispatch(prestationsActions.updateTypologie(values));
        }
    }

    const initialValues = {
        id: props.typologie?.id ?? null,
        libelle: props.typologie?.libelle ?? '',
        couleur: props.typologie?.couleur ?? '#000000',
        consoEauLitresParBac: props.typologie?.consoEauLitresParBac ?? '',
    }

    if (props.loading) return <Loader/>;

    return (
        <>
            <PageTitle
                title={mode === "create" ? "Nouvelle Typologie de Lavage" : "Modifier la Typologie"}
                icon={<WaterIcon/>}
            />
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={typologieLavageValidationSchema}
                onSubmit={(values, {setSubmitting}) => {
                    handleSubmit(values);
                }}
            >
                {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting}) => (
                    <form onSubmit={handleSubmit}>
                        <TypologieLavageDataField
                            values={values}
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                        />
                        <Grid container justifyContent="center" style={{marginTop: '2rem'}}>
                            <Grid size={4}>
                                <SubmitButton submitting={isSubmitting && !props.error}/>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </Formik>
        </>
    );
}

const mapStateToProps = (state) => ({
    typologie: state.prestations.typologieLavage,
    loading: state.prestations.loading,
    error: state.prestations.error
});

export default connect(mapStateToProps)(TypologieLavageNewOrEdit);
